import { toast, ToastContent, ToastOptions } from 'react-toastify';

interface ShowToastOption {
  toastContent: ToastContent;
  toastOptions?: ToastOptions;
}

const showToast = ({ toastContent, toastOptions }: ShowToastOption) => {
  toast(toastContent, toastOptions ?? {});
};

export default showToast;
